import { useState } from "react";
import { cn } from "@/utils/Functions";
import { AnimatePresence, motion } from "motion/react";
import {
  Navigation,
  FillContractScreen,
  PreviewScreen,
  ContractTypeSelection,
} from "./components/contract-composer";
import { type Screen } from "./components/contract-composer/screens/types";
import { useSearchParams } from "react-router-dom";

const screens = [
  {
    id: "initial",
    component: ContractTypeSelection,
  },
  {
    id: "fill",
    component: FillContractScreen,
  },
  {
    id: "preview",
    component: PreviewScreen,
  },
] as const;

function ComposerPage() {
  const [searchParams] = useSearchParams();
  const parsedScreenId = Number(searchParams.get("screenId"));
  const screenId = Number.isFinite(parsedScreenId) ? parsedScreenId : 0;
  const initialScreen = screens[screenId] ?? screens[0];

  const [selectedScreen, setSelectedScreen] = useState<Screen>(initialScreen);

  const handleScreenChange = (nextScreenId: string) => {
    const screen = screens.find((s) => s.id === nextScreenId);
    if (screen) {
      setSelectedScreen(screen);
    }
  };

  const layoutModes = {
    dual: ["initial", "fill"],
    single: ["preview", "save"],
  };

  const isDualLayout = layoutModes.dual.includes(selectedScreen.id);

  return (
    <div className="pb-32">
      <div
        className={cn(
          "max-w-[1100px] mx-auto h-auto md:min-h-screen text-white gap-4 grid grid-cols-1",
          {
            "grid md:grid-cols-[2fr_6fr]": isDualLayout,
            "grid md:grid-cols-1 grid-cols-1": !isDualLayout,
            "px-4 md:px-16 pr-4 md:pr-32": isDualLayout,
            "p-0": !isDualLayout,
          },
        )}
      >
        {isDualLayout && (
          <Navigation
            selectedScreen={selectedScreen}
            setSelectedScreen={handleScreenChange}
          />
        )}
        <AnimatePresence mode="wait">
          <motion.div>
            <selectedScreen.component
              selectedScreen={selectedScreen}
              setSelectedScreen={handleScreenChange}
            />
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
}

export default ComposerPage;
